import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { RoleEnum } from '@/api/rest/resources/types/membership';
import { useAccountPageRoutes } from '@/hooks/useAccountPageRoutes';
import { useUserMe } from '@/hooks/useUserMe';

export const RequireAdminRole: FC = () => {
  const user = useUserMe().data;
  const { restrictedAccess } = useAccountPageRoutes();

  if (user.membership.role !== RoleEnum.admin) {
    return <Navigate to={restrictedAccess} replace />;
  }
  return <Outlet />;
};
